export enum EAsideOutlets {
  GlobalAsideOutlet = 'globalAside',
  SidebarAsideOutletPrimary = 'aside',
  SidebarAsideOutletSecondary = 'asideNested',
}

export const DEFAULT_ASIDE_OUTLET = EAsideOutlets.SidebarAsideOutletPrimary;
